import ReactDOM from "react-dom/client";
import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import NotificationEventTypes from "../../constants/notificationEventsEnum";
import { useWorkflow } from "../../context/WorkflowContext";

function InterviewModal({
  onClose,
  firstRegistrationId,
  interviewData,
  refreshOnSubmitSuccess,
}) {
  const token = localStorage.getItem("token");

  const { workflowParams } = useWorkflow();

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
    getValues,
  } = useForm();

  useEffect(() => {
    if (interviewData) {
      const todayDate = new Date().toISOString().split("T")[0];
      const invalidDate = "0001-01-01T00:00:00";

      reset({
        isInterviewTaken: true,
        interviewDate: todayDate,
        interviewRemarks: "",
      });
    }
  }, [interviewData, reset]);

  const saveInterview = async (data) => {
    const formData = {
      ...data,
      id: firstRegistrationId,
      isInterviewTaken: true,
      interviewUpdatedBy: localStorage.getItem("userId"),
      FormId: 78,
      NotificationEventTypeIds: NotificationEventTypes.ACCEPT.toString(),
      Workflow: {
        ...workflowParams.Workflow,
        WorkflowStepId: workflowParams.Workflow.WorkflowStepId,
        CreatedBy: Number(localStorage.getItem("userId")),
        Comments: data.interviewRemarks,
      },
    };

    // console.log(formData);
    // return;

    try {
      const response = await post(
        "Student/UpdateParentInterviewStatus",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Success!");
        onClose();
        refreshOnSubmitSuccess();
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Interview Remarks</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveInterview)}
              >
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Remarks<span className="text-danger fs-9">*</span>
                  </label>
                  <textarea
                    {...register(`interviewRemarks`, {
                      required: "This field is required.",
                    })}
                    className="form-control"
                  ></textarea>
                  {errors.interviewRemarks && (
                    <small className="text-danger">
                      {errors.interviewRemarks.message}
                    </small>
                  )}
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default InterviewModal;
